import React from "react";

import MaterialTable from "material-table";

import CreationForm from "./form/place-creation-form";

import service from '../../../plas/map/places/service.jsx';

function TablePlaces({ 
  open, 
  title, 
  noDataMessage, 
  deleteMessage, 
  rootCategory, 
  initialPlace, 
  options 
}) {

  const [create, setCreate] = React.useState(false);
  const tableRef = React.useRef();
  
  return (
    <div>
      <MaterialTable
        tableRef={tableRef}
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} de {count}",
            labelRowsPerPage: "Filas por página",
            labelRowsSelect: "Filas",
            firstAriaLabel: "Primera página",
            firstTooltip: "Primera página",
            previousAriaLabel: "Página anterior",
            previousTooltip: "Página anterior",
            nextAriaLabel: "Próxima página",
            nextTooltip: "Próxima página",
            lastAriaLabel: "Última página",
            lastTooltip: "Última página",
          },
          toolbar: {
            nRowsSelected: "{0} filas(s) seleccionadas",
            searchTooltip: "Buscar",
            searchPlaceholder: "Buscar",
          },
          header: {
            actions: "Acciones",
          },
          body: {
            emptyDataSourceMessage: noDataMessage,
            deleteTooltip: "Eliminar",
            editTooltip: "Editar",
            filterRow: {
              filterTooltip: "Filtrar",
            },
            editRow: {
              saveTooltip: "Confirmar",
              cancelTooltip: "Cancelar",
              deleteText: deleteMessage,
            },
          },
        }}
        title={title}
        columns={[
          { title: "ID", field: "id",  editable: "never", cellStyle: {width:"5%"}, headerStyle:{width:"5%"},
            render: rowData => <span>{rowData.id}</span> },
          { title: "Categoría", field: "placeCategory.name", editable: "never", sorting: false, cellStyle: {width:"20%"}, headerStyle:{width:"20%"},
            render: rowData => <span>{ rowData.placeCategory.name }</span> },
          { title: "Nombre", field: "name", sorting: false, cellStyle: {width:"40%"}, headerStyle:{width:"40%"},
            render: rowData => <span>{rowData.name}</span> },
          { title: "Direccion", field: "address", editable: "never", sorting: false, cellStyle: {width:"25%"}, headerStyle:{width:"25%"},
            render: rowData => <span>{ rowData.address }</span> }
        ]}
        actions={[
          rowData => ({
            icon: "launch",
            tooltip: "Abrir",
            onClick: (event, rowData) => open(event, rowData)
          }),
          {
            icon: "add",
            tooltip: "Crear negocio",
            isFreeAction: true,
            onClick: (event) => { setCreate(true); },
          },
        ]}
        editable={{
          isDeletable: rowData => true,
          onRowDelete: (oldData) =>
            new Promise((resolve) => {
              service.api.places.delete(oldData.id,(response) => {
                resolve();
              });
            })
        }}
        options={{
          sorting: false,
          draggable: false,
          addRowPosition: "first",
          actionsColumnIndex: -1,
          tableLayout: 'auto',
          actionsCellStyle: {width: "10%"},
          rowStyle: {
            fontSize: 15,
          }
        }}
        data={ query =>
          new Promise((resolve, reject) => {
            let from = query.page * query.pageSize;
            let to = from + query.pageSize;
            let keyword = query.search;

            service.api.places.getPage(from, to, rootCategory, false, keyword, (response) => {
              if (response.result != null) {
                resolve({
                  data: response.result.data,
                  page: query.page,
                  totalCount: response.result.total,
                });
              } else {
                reject();
              }
            }); 
          })
        }
      />
      <CreationForm 
        open={create}
        rootCategory={rootCategory}
        initialPlace={initialPlace}
        options={options}
        onCancel={() => {
          setCreate(false)
        }} 
        onCreated={() => { 
          setCreate(false); 
          if (tableRef.current !== undefined && tableRef.current != null) {
            tableRef.current.onQueryChange()
          }
        }}/>
    </div>
  );

}


export default TablePlaces;